export function resolveUnitCodeForImport(
  unitCode: unknown,
  unitByCode: Map<string, string>
): { unitDocId: string } | { error: string } {
  if (typeof unitCode !== "string") {
    return { error: "unitCode is required" };
  }
  const unitDocId = unitByCode.get(unitCode);
  if (!unitDocId) {
    return { error: `Unit not found for code: ${unitCode}` };
  }
  return { unitDocId };
}
